export enum CommentImportance {
  INFORMATION = 'INFORMATION',
  WARNING = 'WARNING',
  IRREGULARITY = 'IRREGULARITY',
}
